// Story section headings mark boundaries BETWEEN assembled passages.
// Convert those slots using the already-quantised timeline clip starts, so
// cross-camera frame rates and trimmed durations cannot shift the markers.
export function assemblySectionMarkers(paper,starts,totalFrames){
 const count=paper?.blocks?.length||0;
 if(!count||!Array.isArray(starts)||starts.length!==count)return [];
 return (paper.sectionHeadings||[]).flatMap(section=>{
  const title=typeof section?.title==='string'?section.title.trim():'';
  const slot=section?.beforeIndex;
  if(!title||!Number.isInteger(slot)||slot<0||slot>count)return [];
  const frame=slot===count?totalFrames:starts[slot];
  if(!Number.isSafeInteger(frame)||frame<0)return [];
  return [{id:section.id,title:title.slice(0,100),beforeIndex:slot,frame}];
 });
}
